import Vue from 'vue'
import store from 'vuex'
import axios from 'axios'
import checkToken from '@/utils/checkToken'
import { Loading, Message } from 'element-ui'
import API from './api'
const qs = require('qs')
import uuidv1 from 'uuid/v1'
import both from '@/utils/storage'
import lang from '@/assets/lang'
let langCountry = both.storage.get('langCountry')
langCountry = langCountry.length == 0 ? 'en' : langCountry
// console.log(lang, langCountry)
// 设置uuid
let uuid = both.storage.get('uuid')
if (uuid.length == 0) {
  uuid = uuidv1()
  both.storage.set('uuid', uuid)
}

// 创建axios实例
const service = axios.create({
  timeout: 30000,     // 请求超时时间
  baseURL: API.web, // 买家端API
  paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
})

// request拦截器
service.interceptors.request.use(config => {
  const { loading } = config
  // 如果是put/post请求，用qs.stringify序列化参数
  const is_put_post = config.method === 'put' || config.method === 'post'
  const is_json = config.headers['Content-Type'] === 'application/json'
  const is_file = config.headers['Content-Type'] === 'multipart/form-data'
  if (is_put_post && is_json) {
    config.data = JSON.stringify(config.data)
  }
  if (is_put_post && !is_file && !is_json) {
    config.data = qs.stringify(config.data, { arrayFormat: 'repeat' })
  }
  /** 配置全屏加载 */
  if (loading !== false) {
    config.loading = Loading.service({
      fullscreen: true,
      background: 'rgba(255,255,255,.3)',
      spinner: 'el-icon-loading',
      text: 'Loading',
      lock: false
    })
  }
  /* 切换baseUrl */
  if (config.ApiBase) {
    config.baseURL= API.base
  }

  /* 全局添加uuid */
  config.headers['uuid'] = uuid

  /* 全局language*/
  config.headers['language'] = langCountry

  /*  */
  // 获取访问Token
  let accessToken = both.storage.get('token').access_token
  if (accessToken && config.needToken) {
    config.headers['Authorization'] = accessToken
  }

  return config
}, error => {
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  async response => {
    /* &amp; 替换 & */
    if (typeof response.data == 'object') {
      if (response.data.code == 200) {
        // 如果不是表格等blob格式才替换
        let _size = response.data.size > 0
        let _type = response.data.type == 'application/ms-excel'
        if (!_size && !_type) {
          response.data = JSON.parse(JSON.stringify(response.data).replace(/&amp;/g,'&'))
        }
      }else{
        await closeLoading(response)
        return Promise.reject(response.data)
      }
    }
    await closeLoading(response)
    return response.data
  },
  async error => {
    await closeLoading(error)
    if (error.response && error.response.status == 500) {
      Message({
        // message: error.response.data.message,
        message: lang[langCountry].Data_acquisition_failed,
        type: 'error',
        duration: 5 * 1000
      })
    } else if(error.response) {
      try{
        Message({
          message: error.response.data.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }catch(err){}
    } else {
      Message({
        message: lang[langCountry].Request_timed_out,
        type: 'error',
        duration: 5 * 1000
      })
    }
    /*if (process.server) return Promise.reject(error)
    await closeLoading(error)
    const error_response = error.response || {}
    const error_data = error_response.data || {}
    if (error_response.status === 403) {
      const { $store, $router, $route } = Vue.prototype.$nuxt
      if (!Storage.getItem('refresh_token')) return
      $store.dispatch('cart/cleanCartStoreAction')
      $store.dispatch('user/removeUserAction')
      $store.dispatch('user/removeAccessTokenAction')
      $store.dispatch('user/removeRefreshTokenAction')
      $router.push(`/login?forward=${$route.fullPath}`)
      return Promise.reject(error)
    }
    if (error.config.message !== false) {
      let _message = error.code === 'ECONNABORTED' ? '连接超时，请稍候再试！' : '网络错误，请稍后再试！'
      Vue.prototype.$message.error(error_data.message || _message)
    }*/
    return Promise.reject(error)
  }
)

/**
 * 关闭全局加载
 * @param target
 */
const closeLoading = (target) => {
  if (!target.config || !target.config.loading) return true
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      target.config.loading.close()
      resolve()
    }, 200)
  })
}

export default function request(options) {
  // 如果是服务端或者是请求的刷新token，不需要检查token直接请求。
  /*if (process.server || options.url.indexOf('passport/token') !== -1) {
    return service(options)
  }*/
  if (options.needToken) {
    return new Promise((resolve, reject) => {
      checkToken(options).then(() => {
        service(options).then(resolve).catch(reject)
      })
    })
  }else{
    return service(options)
  }
}
